import DetailModel from '@/components/V2/ModalContent';

import './VolumeBucketTablesStyle.css';

import { useEffect, useState } from 'react';

import Button from '@/components/FormFields/Button';
import { useLazyGetEZPVVolumeBucketDetailsQuery } from '@/store/api/dashboard';
import { VolumeBucketResponse } from '@/types/Reports';
import { SuccessResponse } from '@/types/Success';

import ReportsLoader from '../CustomerDetailModal/ReportsLoader';

interface VolumeBucketForEZPVModelsProps {
  modalOpen: boolean;
  setModalOpen: (state: boolean) => void;
  selectedMonth: number | undefined;
  volumeBucket: number | undefined;
  volumeBucketLabel: string;
  isTableView: boolean;
  titleClassName?: string;
  isMonthBar?: boolean;
}

const VBVolumeTemplete1 = [1, 2, 3, 14, 18, 25];
const VBVolumeTemplete2 = [12, 22, 23, 4, 13, 5, 6, 7, 8, 9, 47, 71, 77, 79];
const VBVolumeTemplete3 = [26, 27, 28, 29, 30];
const VBVolumeTemplete4 = [84];

const VolumeBucketForEZPVModels: React.FC<VolumeBucketForEZPVModelsProps> = ({
  modalOpen,
  setModalOpen,
  selectedMonth,
  volumeBucketLabel,
  isTableView,
  volumeBucket,
  titleClassName,
}) => {
  const [data, setData] = useState<VolumeBucketResponse>();
  const [triggerGetVolumeBucketDetails, { isFetching: isFetching, isLoading: isLoading }] =
    useLazyGetEZPVVolumeBucketDetailsQuery();

  useEffect(() => {
    const parms = `?monthnumber=${selectedMonth}`;

    if (modalOpen) {
      triggerGetVolumeBucketDetails(`/EzShipRemainderByMonth${parms}`)
        .unwrap()
        .then((response: SuccessResponse<VolumeBucketResponse>) => {
          setData(response.data);
        })
        .catch(error => console.error('Error fetching customer profile:', error));
    }
  }, [selectedMonth, modalOpen, triggerGetVolumeBucketDetails]);

  return (
    <DetailModel
      isOpen={modalOpen}
      onClose={() => {
        setModalOpen(!modalOpen);
      }}
      hideMainScroll
      className="v2-w-[992px] md:!v2-w-[716px] lg:!v2-w-[853px] !v2-p-0 sm:v2-mx-4 xs:v2-mx-4"
      title={volumeBucketLabel}
      titleClassName={titleClassName}
      headerContainerClassName="v2-p-[24px]"
      closeIconClassName="v2-h-[24px] v2-w-[24px] v2-rounded-full v2-bg-[#E8ECEB] v2-text-primary hover:v2-text-primary"
    >
      {isLoading || isFetching ? (
        <div className="v2-mb-8">
          <ReportsLoader />
        </div>
      ) : (
        // <div className="v2-max-h-[598px] v2-h-fit v2-overflow-auto">
        <div className="v2-max-h-[60vh] v2-h-fit v2-overflow-auto v2-flex v2-flex-col v2-gap-6">
          {isTableView && (
            <div className="v2-px-6 v2-pb-6 custom-scroll v2-h-[432px] v2-overflow-auto">
              <div className="v2-rounded-xl v2-border v2-border-[#EAECF0] v2-overflow-hidden md:v2-overflow-hidden sm:v2-overflow-auto xs:v2-overflow-auto">
                <table className="new-pv-table">
                  <thead>
                    <tr>
                      <th>EZ Ship ID</th>
                      <th>Next Date</th>
                      <th>Name</th>
                      <th>PV</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {volumeBucket &&
                      VBVolumeTemplete1.includes(volumeBucket) &&
                      data &&
                      data?.length > 0 &&
                      data?.map((item, index) => {
                        if ('orderNumber' in item && 'orderDate' in item) {
                          return (
                            <tr key={index}>
                              <td>{item.orderNumber}</td>
                              <td>{item.orderDate}</td>
                              <td>{item.fullName}</td>
                              <td>{item.pv}</td>
                              <td>${item.amount}</td>
                            </tr>
                          );
                        } else if ('ezShipID' in item && 'nextRunDate' in item) {
                          return (
                            <tr key={index}>
                              {/* @ts-ignore */}
                              <td>{item.ezShipID}</td>
                              {/* @ts-ignore */}
                              <td>{item.nextRunDate}</td>
                              {/* @ts-ignore */}
                              <td>{item.name}</td>
                              {/* @ts-ignore */}
                              <td>{item.pv}</td>
                              {/* @ts-ignore */}
                              <td>${item.amount}</td>
                            </tr>
                          );
                        }
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {volumeBucket && VBVolumeTemplete3.includes(volumeBucket) && !isTableView && data && data?.length > 0 && (
            <div className="v2-px-6 v2-pb-6 custom-scroll v2-h-[432px] v2-overflow-auto">
              <div className="v2-rounded-xl v2-border v2-border-[#EAECF0] v2-overflow-hidden md:v2-overflow-hidden sm:v2-overflow-auto xs:v2-overflow-auto">
                <table className="new-pv-table">
                  <thead>
                    <tr>
                      <th>EZ Ship ID</th>
                      <th>Next Date</th>
                      <th>Name</th>
                      <th>PV</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {volumeBucket &&
                      VBVolumeTemplete3.includes(volumeBucket) &&
                      data &&
                      data?.length > 0 &&
                      !isTableView &&
                      data?.map((item, index) => {
                        if ('autoOrderID' in item && 'nextDate' in item) {
                          return (
                            <tr key={index}>
                              <td>{item.autoOrderID}</td>
                              <td>{item.nextDate}</td>
                              <td>{item.name}</td>
                              <td>{item.pv}</td>
                              <td>${item.amount}</td>
                            </tr>
                          );
                        }
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {volumeBucket &&
            VBVolumeTemplete1.includes(volumeBucket) &&
            data &&
            data?.length > 0 &&
            !isTableView &&
            data?.map((item, index) => {
              if ('orderNumber' in item && 'orderDate' in item) {
                return (
                  <div key={index} className="v2-px-6">
                    <div className="v2-rounded-xl v2-border v2-border-[#EAECF0] v2-overflow-hidden">
                      <table className="new-pv-table">
                        <thead>
                          <tr>
                            <th>Order Number</th>
                            <th>{item.orderNumber}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Order Date</td>
                            <td>{item.orderDate}</td>
                          </tr>
                          <tr>
                            <td>Full Name</td>
                            <td>{item.fullName}</td>
                          </tr>
                          <tr>
                            <td>PV</td>
                            <td>{item.pv}</td>
                          </tr>
                          <tr>
                            <td>Amount</td>
                            <td>{item.amount}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                );
              }
            })}
          {volumeBucket && VBVolumeTemplete2.includes(volumeBucket) && data && (
            <div className="v2-px-6 v2-pb-6 custom-scroll v2-h-[432px] v2-overflow-auto">
              <div className="v2-rounded-xl v2-border v2-border-[#EAECF0] v2-overflow-hidden v2-mb-4">
                {data?.map((item, index) => {
                  if ('name' in item && 'customerID' in item) {
                    return (
                      <div key={index} className="v2-flex v2-items-center v2-border-b v2-border-[#EAECF0]">
                        <div className="v2-px-3 v2-py-[15px] v2-grid v2-gap-1 v2-w-full">
                          <p>Customer Number</p>
                          <p>Name</p>
                        </div>
                        <div className="v2-px-3 v2-py-[15px] v2-grid v2-gap-1 v2-w-full">
                          <p>{item.customerID}</p>
                          <p>{item.name}</p>
                        </div>
                      </div>
                    );
                  }
                })}
              </div>
            </div>
          )}
          {volumeBucket && VBVolumeTemplete4.includes(volumeBucket) && data && (
            <div className="v2-px-6 v2-pb-6 custom-scroll v2-h-[432px] v2-overflow-auto">
              <div className="v2-rounded-xl v2-border v2-border-[#EAECF0] v2-overflow-hidden v2-mb-4">
                {data?.map((item, index) => {
                  if ('customerName' in item && 'orderNumber' in item && 'customerID' in item) {
                    return (
                      <div key={index} className="v2-flex v2-items-center v2-border-b v2-border-[#EAECF0]">
                        <div className="v2-px-3 v2-py-[15px] v2-grid v2-gap-1 v2-w-full">
                          <p>Customer Name</p>
                          <p>Customer ID</p>
                          <p>Order Number</p>
                        </div>
                        <div className="v2-px-3 v2-py-[15px] v2-grid v2-gap-1 v2-w-full">
                          <p>{item.customerName}</p>
                          <p>{item.customerID}</p>
                          <p>{item.orderNumber}</p>
                        </div>
                      </div>
                    );
                  }
                })}
              </div>
            </div>
          )}
        </div>
      )}
      <div className="v2-p-6 v2-pt-5 v2-border-t v2-border-[#EAECF0] v2-flex v2-items-center v2-justify-end v2-bg-white v2-rounded-b-xl">
        <Button
          scheme="secondary"
          type="button"
          variant="outlined"
          className="v2-px-[18px] v2-py-[10px] v2-rounded-xs v2-text-base v2-font-sweet-sans-pro-medium v2-font-medium v2-text-[#344054] v2-border-[#D0D5DD] v2-shadow-xs"
          onClick={() => setModalOpen(false)}
        >
          Close
        </Button>
      </div>
    </DetailModel>
  );
};

export default VolumeBucketForEZPVModels;
